<template>
  <div class="bg-lightGray" style="padding-top:100px;">
    <div class="container">
      <div class="col pt-0 pb-0">
        <nav area-label="breadcrumb">
          <ol class="breadcrumb bg-light" style="font-size: 14px;">
            <li class="breadcrumb-item"><a href="/recruit" style="color: #007bff8a;">Home</a></li>
            <li class="breadcrumb-item"><a href="/recruit/client-job-dashboard" style="color: #007bff8a;">Dashboard</a></li>
            <li class="breadcrumb-item active text-dark" aria-current="page">Edit-job</li>
          </ol>
        </nav>
      </div>
      <div class="row">
        <div class="col-md-12 col-lg-8 mb-5">
          <div class="p-4 mb-3 bg-white light-shadow post_shadow pt-0">
            <div class="p-5 text-secondary">
              <h1 class="text-primary text-left" style="font-size:1.75rem !important;">Edit your jobs</h1>
              <form ref="postJob-form">
                <div class="gap10"></div>
                <div class="row mt-0">
                  <!-- <div class="col-lg-12 form-group">
                    <label for="title" style="font-size:15px;">Job title<span style="color:red;">*</span></label>
                    <v-autocomplete v-model="toPost.jobs.job_designation" @input="getJobRole" :items="designations" item-text="text" item-value="id" :class="{'is-invalid':typeof validate.response.jobTitle != 'undefined' && !validate.response.jobTitle.val}" clearable outlined ></v-autocomplete>
                    <div class="invalid-feedback" v-if="(typeof validate.response.jobTitle != undefined && can_post !=0 )">
                        {{ validate.response.jobTitle.msg }}
                    </div>
                  </div> -->
                  <div class="col-lg-12 form-group">
                    <label for="title" style="font-size:15px;">Job title<span style="color:red;">*</span></label>
                    <input id="job_title" class="form-control fields" v-model="toPost.jobs.job_designation" type="text" placeholder="Select Title" list="designations" @input="getJobRole">
                    <datalist id="designations">
                      <option :key="item.value" v-for="item in designations">{{item.text}}</option>
                    </datalist> 
                    <div class="job_error" v-if="(!toPost.jobs.job_designation && can_post !=0 )">
                        Select Job title
                    </div>
                  </div>
                </div>
                <div class="row mt-0 form-label-group" style="display:none">
                  <div class="col-lg-6 pt-0 pb-0" >
                    <label for="title" style="font-size:15px;">jobs role<span style="color:red;">*</span></label>
                    <input list="roles" class="form-control fields" type="text" name="jobrole">
                  </div>
                </div>
                <div class="row form-label-group mt-0">
                  <div class="col-lg-6 pt-0 pb-0">
                    <label for="title" style="font-size:15px;">Job location<span style="color:red;">*</span></label>
                    <v-autocomplete v-model="t_city" label="Select location" :items="states" item-text="text" item-value="id" :searchable="true" @change="showSubcity" clearable chips outlined multiple deletable-chips> 
                      <template slot="item" slot-scope="data">
                        <template>
                          <v-list-item-content>{{data.item.text}}</v-list-item-content>
                        </template>
                      </template>
                    </v-autocomplete>
                    <div class="job_error" v-if="(!toPost.cities.length && can_post !=0 )">
                        Select Location
                    </div>
                  </div>
                  <div class="col-lg-6 pt-0 pb-0" v-show="subCity">
                    <label for="title" style="font-size:15px;">Sub location</label>
                    <v-autocomplete v-model="t_location" label="Select sublocation" @change="setSublocations" :items="sublocations" item-text="text" item-value="value" clearable chips outlined multiple deletable-chips>
                      <template slot="item" slot-scope="data">
                        <template>
                          <v-list-item-content>{{data.item.text}}</v-list-item-content>
                        </template>
                      </template>
                    </v-autocomplete>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6 pt-0 pb-0">
                    <label for="title" style="font-size:15px;">Qualification<span style="color:red;">*</span></label>
                    <v-autocomplete v-model="t_courses" label="Select qualification" :searchable="true" item-text="text" item-value="id" @change="getBranches" :items="courses"  clearable chips outlined multiple deletable-chips>
                      <template slot="item" slot-scope="data">
                        <template>
                          <v-list-item-content>{{data.item.text}}</v-list-item-content>
                        </template>
                        
                      </template>
                    </v-autocomplete>
                    <div class="job_error" v-if="(!toPost.courses.length && can_post !=0 )">
                        Select Qualification
                    </div>
                  </div>
                  <div class="col-lg-6 pt-0 pb-0" v-show="branches.length != 0">
                    <label for="title" style="font-size:15px;">Branch</label>
                    <v-autocomplete v-model="t_branches" label="Select course" @input="setBranches" :searchable="true" :items="branches" item-text="text" item-value="value" clearable chips outlined multiple deletable-chips>
                      <template slot="item" slot-scope="data">
                        <template>
                          <v-list-item-content>{{data.item.text}}</v-list-item-content>
                        </template>
                      </template>
                    </v-autocomplete>
                  </div>
                </div>
                <h4 class="text-primary text-left mt-4">Salary per month</h4>
                <div class="row form-label-group">
                  <div class="col-lg-6">
                    <label for="title" style="font-size:15px;">Minimum<span style="color:red;">*</span></label>
                    <input id="salary_min" class="form-control fields" v-model="toPost.jobs.salary_range_from" type="number" placeholder=" " @keydown.space.prevent>
                    <div class="job_error" v-if="(typeof validate.response.min_salary != 'undefined' && !validate.response.min_salary.val)">
                        {{validate.response.min_salary.msg }}
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <label for="title" style="font-size:15px;">Maximum</label>
                    <input id="salary_max" class="form-control fields" v-model="toPost.jobs.salary_range_to" type="number" placeholder=" " @keydown.space.prevent>
                    <div class="job_error" v-if="(typeof validate.response.max_salary != 'undefined' && !validate.response.max_salary.val && toPost.jobs.salary_range_to)">
                        {{validate.response.max_salary.msg }}
                    </div>
                  </div>
                </div>
                <div class="row form-label-group">
                  <div class="col-lg-8">
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" id="hidesalary" name="hidesalary" @click="hideSalary">
                      <label class="custom-control-label" for="hidesalary" style="font-size:1rem;"> Hide salary to applicants</label>
                    </div>
                  </div>
                </div>
                <div class="row form-label-group mt-0">
                  <div class="col-lg-6 pb-0">
                    <label class="fz" style="font-size:15px;">Job type<span style="color:red;">*</span></label>
                    <v-select  v-model="default_type" label="Select type" height="55px" name="jobtype" :items="job_type" item-value="value" item-text="text"  clearable outlined chips @change="setJobType"></v-select>
                    <div class="job_error" style="margin-top:-25px; margin-bottom:12px;"  v-if="(!toPost.jobs.job_type && can_post !=0 )">
                        Select Job type
                    </div>
                  </div>
                  <div class="col-lg-6 pb-0">
                    <label class="fz" style="font-size:15px;">Hiring Process<span style="color:red;">*</span></label>
                    <v-select name="hireprocess" label="Select hiring process" v-model="default_hiring" :items="hire_process" item-text="text" item-value="text" @change="setHiringProcess" clearable chips outlined multiple deletable-chips></v-select>
                    <div class="job_error" style="margin-top:-25px;" v-if="(!toPost.jobs.hiring_process.length && can_post !=0 )">
                        Select Hiring process
                    </div>
                  </div>
                </div>
                <div class="row form-label-group">
                  <div class="col-lg-12">
                    <label for="title" style="font-size:15px;">Job description<span style="color:red;">*</span></label>
                    <vue-editor v-model="toPost.jobs.job_description" class="editor" @input="validate.checkIfEmpty(toPost.jobs.job_description, 'description', 'Enter Description')"></vue-editor>
                    <div class="job_error"  v-if="(typeof validate.response.description != undefined && can_post !=0 )">
                        {{ validate.response.description.msg }}
                    </div>   
                  </div>
                </div>
                <!-- <div class="row form-group">
                  <div class="col-lg-12">
                    Add Questionnaires to job <span class="btn btn-outline-primary ml-3" data-toggle="modal" data-target="#questionaire">Add</span>
                  </div>
                </div> -->
                <div class="row">
                  <div class="col-lg-12 text-right">
                    <button type="button" @click="addMore()" class="btn btn-outline-primary"><span v-show="!moreInfo"> + </span><span v-show="moreInfo">- </span>Additional information</button>
                  </div>
                </div>
                <div id="myDIV" style="display: block;" v-show="moreInfo">
                  <div class="gap30"></div>
                  <h4 class="text-primary text-left">More information</h4>
                  <div class="row form-label-group">
                    <div class="col-lg-6">
                      <label class="fz">No of vaccancies</label>
                      <input class="form-control fields" v-model="toPost.jobs.number_of_vacancy" type="number" name="vaccancies">
                    </div>
                    <div class="col-lg-6">
                      <label class="fz">Highest qualification mark</label>
                      <input class="form-control fields" v-model="toPost.jobs.hq_marks_percentage_from" type="number" min="0" name="hqmark">
                    </div>
                  </div>
                  <div class="gap10"></div>
                  <div class="row form-label-group">
                    <div class="col-lg-6">
                      <label class="fz">Year of passing (From)</label>
                      <v-select v-model="toPost.jobs.year_of_passing_from" name="year_of_passing_from" :items="years" item-value="value" item-text="value" clearable outlined></v-select>
                      <!-- <input type="date" v-model="toPost.jobs.year_of_passing_from" name="passout" class="form-control fields"> -->
                    </div>
                    <div class="col-lg-6">
                      <label class="fz">Year of passing (To)</label>
                      <v-select v-model="toPost.jobs.year_of_passing_to" name="year_of_passing_to" :items="years" item-value="value" item-text="value" clearable outlined></v-select>
                      <!-- <input type="date" v-model="toPost.jobs.year_of_passing_to" name="passout" class="form-control fields"> -->
                    </div>
                  </div>
                  <div class="gap10"></div>
                  <div class="row form-label-group">
                    <div class="col-lg-6">
                      <label class="fz" style="font-size:15px;">Skills required</label>
                      <!-- <input list="skills" class="form-control fields" type="text" name="skills"> -->
                      <!-- <select name="skills" id="skills"></select> -->
                      <v-select v-model="t_skills" :searchable="true" @input="setSkills" :items="skills" item-text="text" item-value="value"  clearable chips outlined multiple deletable-chips></v-select>
                        <!-- <input id="job_skill" class="form-control fields" v-model="t_skills" type="text" placeholder="Select skill" list="skills" @input="setSkills">
                        <datalist id="skills">
                          <option :key="item.value" v-for="item in skills">{{item.text}}</option>
                        </datalist>  -->
                      </div>
                    <div class="col-lg-6">
                      <label class="fz" style="font-size:15px;">Gender</label>
                      <v-select v-model="toPost.jobs.gender" name="gender" :items="gender" item-value="value" item-text="text"  clearable outlined deletable-chips></v-select>
                    </div>
                  </div>
                  <div class="gap10"></div>
                  <div class="row form-label-group">
                    <div class="col-lg-6">
                      <label class="fz" style="font-size:15px;">Experience (Minimum)</label>
                      <v-select id="experience_min" name="experiencemin" v-model="toPost.jobs.experience_from" :items="exp"  item-value="value" item-text="text"  clearable outlined deletable-chips></v-select>
                    </div>
                    <div class="col-lg-6">
                      <label class="fz" style="font-size:15px;">Experience (Maximum)</label>
                      <v-select id="experience_max" name="experiencemax" v-model="toPost.jobs.experience_to" :items="exp" item-text="text" item-value="value"  clearable outlined deletable-chips></v-select>
                    </div>
                  </div>
                  <div class="gap10"></div>
                  <div class="row form-label-group">
                    <div class="col-lg-6" style="display: none;">
                      <label class="fz" style="font-size:15px;">Candidate current location</label>
                      <select name="location" id="location"></select>
                    </div>
                    <div class="col-lg-6">
                      <label class="fz">Last date of Application / Interview</label>
                      <input class="form-control fields" v-model="toPost.jobs.last_date" :min="new Date().toISOString().slice(0,10)" type="date" name="lastdate" @change="getLastDate()">
                    </div>
                  </div>
                </div>
                <div class="mb-7 p-4 bg-white boxRadius2 shadow2" v-if="private_edit">
                <div class="row inputStyle mt-4">
                  <div class="col">
                    <label class="fz">Header Image</label>
                    <v-file-input prepend-icon="mdi-camera" accept="image/*" v-model="header_img" @change="uploadToS3(header_img,'image','header_img')" name="header_img" outlined></v-file-input>
                    <!-- <v-progress-linear :value="header_img_progress" v-if="header_img && header_img_progress !== 100" color="light-blue" height="10" striped></v-progress-linear> -->
                    <div style="font-size:0.5rem" v-if="toPost.job_custom.header_img">{{$S3_bucket_url + toPost.job_custom.header_img}}</div>
                  </div>
                  <div class="col">
                    <label class="fz">Form Image</label>
                    <v-file-input prepend-icon="mdi-camera" accept="image/*" v-model="form_img" @change="uploadToS3(form_img,'image','form_img')" name="form_img" outlined></v-file-input>
                    <div style="font-size:0.5rem" v-if="toPost.job_custom.form_img">{{$S3_bucket_url+toPost.job_custom.form_img}}</div>
                    <!-- <v-progress-linear :value="form_img_progress" v-if="form_img && form_img_progress !== 100" color="light-blue" height="10" striped></v-progress-linear> -->
                    </div>
                  </div>
                  <div class="row inputStyle mt-4">
                    <div class="col-12">
                      <label class="fz">Job Video</label>
                      <v-file-input accept="video/*" v-model="job_video" name="job_video" @change="uploadToS3(job_video,'video','job_video')" outlined></v-file-input>
                      <div style="font-size:0.5rem" v-if="toPost.job_custom.job_video">{{$S3_bucket_url+toPost.job_custom.job_video}}</div>
                      <!-- <v-progress-linear :value="job_video_progress" v-if="job_video && job_video_progress !== 100" color="light-blue" height="10" striped></v-progress-linear> -->
                    </div>
                    <div class="col-12">
                      <label class="fz">Pdf</label>
                      <v-file-input accept="application/pdf" v-model="job_desc_pdf" name="job_desc_pdf" @change="uploadToS3(job_desc_pdf,'pdf','pdf')" outlined></v-file-input>
                      <div style="font-size:0.5rem" v-if="toPost.job_custom.job_desc_pdf">{{$S3_bucket_url+toPost.job_custom.job_desc_pdf}}</div>

                      <!-- <v-progress-linear :value="pdf_progress" v-if="job_desc_pdf && pdf_progress !== 100" color="light-blue" height="10" striped></v-progress-linear> -->
                    </div>
                  </div>
                  <div class="row inputStyle mt-4">
                    <div class="col-lg-12">
                      <label class="fz">Marquee Text</label>
                      <v-text-field id="job_company" class="fields" v-model="toPost.job_custom.marquee_text" type="text" name="marquee_text" outlined></v-text-field>
                    </div>
                  </div>
                </div>
                <div class="row form-label-group">
                  <div class="col-lg-12">
                    <label class="fz">Company name<span style="color: red">*</span></label>
                    <input class="form-control fields" v-model="toPost.jobs.company_name" type="text" name="cname">
                    <div class="job_error"  v-if="(!toPost.jobs.company_name && can_post !=0 )">
                        Enter Company
                    </div>                  
                  </div>
                </div>
                <div class="row form-label-group" v-if="activeJobfair">
                  <div class="col-lg-6 form-group mb-0">
                    <label class="fz">Post job in<span style="color:red;">*</span></label>
                    <v-radio-group v-model="toPost.job_custom.job_fair_display" class="mt-0">
                      <v-radio label="Hireclap only" :value= 1></v-radio>
                      <v-radio label="Jobfair only" :value= 2></v-radio>
                      <v-radio label="Both" :value= 3></v-radio>
                    </v-radio-group>  
                  </div>
                </div>
                <!-- </div> -->
                <div class="row form-label-group" v-if="activeJobfair  && (toPost.job_custom.job_fair_display == 2 || toPost.job_custom.job_fair_display ==3)">
                  <div class="col-lg-6 form-group">
                     <v-autocomplete v-model="selected_jobfairs" label="Choose jobfair" :items="jobfairs" item-text="text" item-value="id" :searchable="true" clearable chips outlined multiple deletable-chips hide-selected> 
                      <template slot="item" slot-scope="data">
                        <template>
                          <v-list-item-content>{{data.item.text}}</v-list-item-content>
                        </template>
                      </template>
                    </v-autocomplete>
                    <div class="job_error" v-if="(!selected_jobfairs.length > 0 && (toPost.job_custom.job_fair_display == 2 || toPost.job_custom.job_fair_display ==3) && can_post !=0)">
                        Choose atlease one jobfair
                    </div>
                  </div>
                </div>
                <div class="row form-label-group" v-if="user_login">
                  <div class="col-lg-6">
                    <label class="fz">Email<span style="color: red">*</span></label>
                    <input class="form-control fields" v-model="user.email" type="text" name="u_email" @keydown.space.prevent> 
                  </div>
                  <div class="col-lg-6">
                    <label class="fz">Password<span style="color: red">*</span></label>
                    <input class="form-control fields" v-model="user.password" type="text" name="u_password" >
                  </div>
                </div>
                <div style="height:30px;"></div>
                <div class="gap20"></div>
                <div class="form-group">
                  <input type="checkbox" name="acceptterms" checked="checked" required=""> I accept Hireclap <a class="text-decoration-none" href="/privacy">privacy policy</a> &amp;<a class="text-decoration-none" href="/terms"> terms &amp; conditions *</a><br>
                  <div class="gap20"></div>
                  <p> ⚠ Asking jobs seeker for any kind of payment is strictly prohibited.</p>
                </div>
                <div class="gap20"></div>
                <div class="row form-group">
                  <div class="col-lg-8">
                    <button class="btn btn-outline-primary" type="submit" @click="editJob" :disabled="isUploading !==0 ">&nbsp; Update &nbsp;</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="job-success" ref="job-success" size="sm" title=" " body-bg-variant="primary" bod body-text-variant="light" hide-footer hide-header hide-backdrop centered>
      <div class="container text-center">Job Edited Successfully</div>
    </b-modal>
  </div>
</template>

<script>
  import { VueEditor} from "vue2-editor/dist/vue2-editor.core.js";
  import AwsUpload from "../../utils/s3upload"
  export default {
    name: 'JobPost',
    components: {
      VueEditor
    },
    beforeMount(){
      this.getDesignations();
      this.getStates();
      this.getcourse();
      this.checkForActiveJobfairs();
      // this.getBranches();
      this.getSkills();
      if(this.$route.params.id){
        this.getJobDetails(this.$route.params.id,this.$route.params.type,this.$route.params.user_id)
      }
      for(var i=2022; i>= 1950; i--){
        this.years.push(i);
      }
    },
    mounted(){
      let data = this.$cookies.get("hire-employer").token;
      if(data){
        new this.$apiAction().getEmployer(data).then(res => { 
          if(res.error == 0){
            this.toPost.jobs.client_user_id = res.data.client_users.client_user_id;
            this.toPost.jobs.posted_by_id = res.data.client_users.client_user_id;
            this.toPost.jobs.company_name = res.data.client_name;
            this.disabled = true;
          }
        });
      }
    },
    data(){
      return{
        activeJobfair: false,
        customToolbar: [
          ["bold", "italic", "underline"], 
          [{ list: "ordered" }, { list: "bullet" }],
          [{ align: "" },{ align: "center" },{ align: "right" },{ align: "justify" }],
          ],
        validate: new this.$valid(),
        default_type:null,
        default_hiring:[],
        jobfairs:[],
        selected_jobfairs: [],
        existing_jobfairs: [],
        version_id : null,
        toPost:{
          jobs:{
              client_user_id: null,
              date_of_posting: new Date(),
              job_designation: '',
              company_name: '',
              // last_date: new Date(new Date().setDate(new Date().getDate() + 30)).toLocaleDateString(),
              last_date: new Date(new Date().setDate(new Date().getDate() + 30)).toISOString().slice(0,10),
              job_type: 1,
              hiring_process: ['Virtual Hiring'],
              job_description: '',
              priority: 1,
              seo_title: null,
              seo_description: null,
              gender: null,
              seo_keywords: null,
              response_type: 1,
              posted_by_id: null,
              salary_range_from: '',
              salary_range_to: null,
              job_role:null,
              salary_flag: 0,
              hq_marks_percentage_from: null,
              number_of_vacancy:null,
              experience_from:null,
              experience_to:null,
              year_of_passing_from:null,
              year_of_passing_to:null
          },
          job_custom:{
            organic_status:1,
            mode:1,
            job_fair_display: 3,
            header_img:null,
            form_img:null,
            job_video:null,
            marquee_text:null,
            job_desc_pdf:null
            },
          courses:[],
          cities:[],
          branches:[],
          categories:[],
          skills:[],
          sublocations:[]
        },
        header_img:null,
        form_img:null,
        job_video:null,
        job_desc_pdf:null,
        t_city:[],
        t_location:[],
        t_cities:[],
        t_courses:[],
        t_branches:[],
        t_skills:[],
        city:[],
        moreInfo: false,
        designations: [],
        subCity : false,
        sublocations : [],
        post_job: false,
        metro_cities: [],
        states: [],
        courses: [],
        branches: [],
        skills: [],
        user_login: false,
        registered:false,
        disabled:false,
        can_post:0,
        private_edit: false,
        exp:[
          { value: 1, text: "0 Month(Fresher)" },
          { value: 6, text: "06 Months" },
          { value: 12, text: "1 Year" },
          { value: 24, text: "2 year" },
          { value: 36, text: "3 year" },
          { value: 48, text: "4 year" },
          { value: 60, text: "5 year" },
          { value: 72, text: "6 year" },
          { value: 84, text: "6+ year" },
          ],
        gender:[
            {value:1, text:'Male'},
            {value:2, text:'Female'},
            {value:3, text:'Both'}
          ],
        hire_process:[
            {value:1, text:'Face to Face'},
            {value:2, text:'Online assessment'},
            {value:3, text:'Telephonic'},
            {value:4, text:'Virtual hiring'},
            {value:5, text:'Walk In'}
          ],
        job_type:[
          {value:1, text:'Full time'},
          {value:2, text:'Work from home'},
          {value:3, text:'Hybrid'},
          {value:4, text:'Part time'},
          {value:5, text:'Internship'},
          {value:6, text:'Apprenticeship'},
          
        ],
        years:[],
        jobDetails:null,
        job:null,
        isUploading: 0
      }
    },
    methods:{
      checkForActiveJobfairs: function() {
        let token = this.$cookies.get("hire-employer").token;
        new this.$apiAction().activeJobfairExists(token).then((res) => {
            if(res.status == true) {
                this.activeJobfair = true;
                this.getJobfairs();
            }
        }).catch((err) => {
            console.log(err)
        });
      },
      async uploadToS3(file,type,field_name){
      this.upload_error = '';
      // this.isUploading = false;
      if(file){
        this.isUploading++;
        const awsUploader = new AwsUpload();
        try {
          var extension = file.name.split('.')[file.name.split('.').length-1]
          var d = new Date();
          var month = d.getMonth() + 1;
          var day = d.getDate();
          var current_date =d.getFullYear() +"/" +(month < 10 ? "0" : "") +month +"/" +(day < 10 ? "0" : "") +day;
          var timestamp = Math.floor(Date.now() / 1000);
          var filename = 'job/'+ field_name+"/"+current_date+'/'+file.name + timestamp + "."+extension
          const response = await awsUploader.uploadImage(file, filename);
          if(response){
            this.isUploading--;
            switch(field_name) {
              case 'header_img': this.toPost.job_custom.header_img= response.url; break;
              case 'form_img': this.toPost.job_custom.form_img =response.url; break;
              case 'job_video': this.toPost.job_custom.job_video = response.url; break;
              case 'pdf': this.toPost.job_custom.job_desc_pdf = response.url; break;
              default: break;
            }
            return true;
          }
        } catch (error) {
          this.isUploading--;
          // this.isUploading = false;
          this.upload_error = "Something wrong with the " + type + " upload. Please try again"
          return false;
        }
      }
    },
      getJobfairs: function(){
      // let token = this.$cookies.get("hire-employer").token;
      new this.$apiAction().getJobfairs().then((res) => {
              if(res.status == true) {
                  res.jobfairs.forEach(element => {
                      {
                          this.jobfairs.push({text:element.job_fair_name,id:element.id})
                      }
                  });
              }
          }).catch((err) => {
              console.log(err)
          });
      },
      openModal: function (type = "") {
        this.open = (type == "")? this.open : type;
        if (this.open == "success") {
          this.$refs["job-success"].show();
        }
      },
      getDesignations: function(){
        this.designations = [];
        new this.$apiAction().getJobDesignations().then(res => {
          res.jobdesignations.forEach((e)=>{
            this.designations.push({
              value : e.designation_id,
              text : e.designation,
              role_id : e.role_id
            })
          })
        });
      },
      getJobRole: function(){
        // console.log(this.toPost.jobs.job_designation);
        var flag = 0;
        this.designations.forEach(desig =>{
          if(desig.text == this.toPost.jobs.job_designation){
            new this.$apiAction().getJobrole().then(res => {
              res.jobroles.forEach(jobrole =>{
                if(jobrole.role_id == desig.role_id){
                  flag = flag+1;
                  this.toPost.jobs.job_role = jobrole.role_id;
                }
              })
              if(flag == 0){
                this.toPost.jobs.job_role = 30;   //set jobrole to 'others'
              }
            })
          }
        });
      },
      setJobeRole: function(jobrole_id){
        this.jobroles = [];
        new this.$apiAction().getJobrole().then(res => {
          res.jobroles.forEach(role => {
            if(jobrole_id == role.role_id){
              this.jobroles.push({role_id:role.role_id,role:role.role})
            }
          })
          console.log(this.jobroles);
        })
      },
      getStates: async function () {
        await new this.$apiAction().getStates().then(async (data) => {
          this.states.push({header: 'Top Metropolitan Cities'})
          await data.states.forEach(async (element) => {
            await element.cities.forEach(city => {
              if(city.top_city == 1){
                this.states.push({text:city.city_name,id:city.city_id, s_id:city.state_id,group:'Top Metropolitan Cities'})
              }
            });
            this.states.push({divider:true})
            this.states.push({header: element.state_name});
           element.cities.forEach(city => {
              if(city.top_city == 0){
                this.states.push({text:city.city_name,id:city.city_id, s_id:city.state_id,group:element.state_name})
              }
          });
        });
          this.states.push({text:'Anywhere india',id:5000,s_id:36,group:'Anywhere india'})
        });
      },
      showSubcity: function () {
        this.subCity = false;
        this.toPost.cities = [];
        this.sublocations = [];
        this.t_city.forEach(city => {
          this.toPost.cities.push({city_id:city})
          this.getSubCities(city)
        })
      },
      getSubCities: function (city_id) {
        var check = true;
        new this.$apiAction().getSubcity(city_id).then((data) => {
          if(data.sublocations){
            this.subCity = true;
            data.sublocations.forEach((element) => {
              if(check == true){
                this.sublocations.push({
                  header: element.city_name
                })
                check = false;
              }else{
                this.sublocations.push({
                  value: element.sublocation_id,
                  text: element.sublocation_name,
                  city_id:city_id
                });
              }
            });
          }else if(this.sublocations.length){
            this.subCity = true;
          }else{
            this.subCity = false;
          }
        });
      },
      setSublocations: function(){
        this.toPost.sublocations=[]
        this.t_location.forEach(data => {
          this.toPost.sublocations.push({sublocation_id:data})
        })
      },
      getcourse: async function () {
        await new this.$apiAction().getCourse().then(async (data) => {
          this.courses.push({header: 'Popular Courses'})
          await data.courses.forEach((element) => {  
            if((element.popular_rating == 1&&element.course_id<=5001 && element.course_id != 37)||(element.popular_rating == 1 &&element.course_id == 5013)){
              this.courses.push({text:element.course_name,id:element.course_id,group:'Popular Courses'})
            }
          });
          this.courses.push({divider:true})
          this.courses.push({header: 'PG Courses'});   
          await data.courses.forEach((element) => {  
            if((element.popular_rating == 0 && element.course_type == 'pg'&&element.course_id<=5001 && element.course_id != 37) || (element.popular_rating == 0 && element.course_type == 'pg'&&element.course_id == 5013)){
              this.courses.push({text:element.course_name,id:element.course_id,group:'PG Courses'})
            }
          });
          this.courses.push({divider:true})
          this.courses.push({header: 'Graduation Courses'});   
          await data.courses.forEach((element) => {  
            if((element.popular_rating == 0 && element.course_type == 'graduation'&&element.course_id<=5001 && element.course_id != 37) || (element.popular_rating == 0 && element.course_type == 'graduation'&&element.course_id == 5013)){
              this.courses.push({text:element.course_name,id:element.course_id,group:'Graduation Courses'})
            }
          });
          this.courses.push({divider:true})
          this.courses.push({header: 'Other Category'});   
          await data.courses.forEach((element) => {  
            if((element.popular_rating == 0 && element.course_type == 'others_category'&&element.course_id<=5001 && element.course_id != 37) || (element.popular_rating == 0 && element.course_type == 'others_category'&&element.course_id == 5013)){
              this.courses.push({text:element.course_name,id:element.course_id,group:'Other Category'})
            }
          });
        });
      },
      getBranches: function(){
        this.branches = [];
        this.toPost.courses = [];
        var check = true;
        this.t_courses.forEach(data => {
          this.toPost.courses.push({course_id: data})
        })
        this.toPost.courses.forEach(course => {
          new this.$apiAction().getSpec(course.course_id).then((data) => {
            check = true;
            if(data.specifications){
              data.specifications.forEach((element) => {
                if(check == true){
                  this.branches.push({
                    header: element.course_name
                  })
                  this.branches.push({
                    value: element.bid,
                    text: element.branch_name,
                  });
                  check = false;
                }else{
                this.branches.push({
                  value: element.bid,
                  text: element.branch_name,
                });
                }
              })
            }
            // data.specifications.forEach((element) => {
            //   this.branches.push({
            //     value: element.bid,
            //     text: element.branch_name,
            //   });
            // });
          });
        })
      },
      setBranches: function () {
        this.toPost.branches = [];
        this.t_branches.forEach(branch => {
          this.toPost.branches.push({branch_id:branch})
        })
      },
      setJobType: function(){
        if(this.default_type){
          this.toPost.jobs.job_type = this.default_type;
        }else{
          this.toPost.jobs.job_type = '';
        }
      },
      setHiringProcess: function(){
        this.toPost.jobs.hiring_process = this.default_hiring;
        console.log(this.toPost.jobs.hiring_process)
      },
      hideSalary: function(e){
        this.toPost.jobs.salary_flag = (e.target.checked)?1:0;
      },
      addMore: function(){
        this.moreInfo = !this.moreInfo;
      },
      getSkills: function(){
        this.skills = []
        new this.$apiAction().getSkills().then((data) => {
          data.skills.forEach((element) => {
            this.skills.push({
              value: element.id,
              text: element.skill,
              slug: element.slug
            })
          })
        }).catch((err) => {
          console.log(err);
        })
      },
      setSkills: function () {
        this.toPost.skills = [];
        this.t_skills.forEach(skill => {
          this.toPost.skills.push({skills_id:skill});
        })
      },
      getLastDate: function () {
        console.log(this.toPost.jobs.last_date);
      },

      updateJobs: async function(job_id) {
          let rem_arr = []; let add_arr = [];
          let token = this.$cookies.get("hire-employer").token;
          if(this.toPost.job_custom.job_fair_display == 1 && this.existing_jobfairs.length > 0) {
            this.existing_jobfairs.forEach(id => {
              rem_arr.push(id);
            });
          } else {
            this.existing_jobfairs.forEach(id => {
              if(!this.selected_jobfairs.includes(id)) rem_arr.push(id);
            });
            this.selected_jobfairs.forEach(id => {
              if(!this.existing_jobfairs.includes(id)) add_arr.push({
                job_fair_id: id,
                job_id: job_id
              });
            });
          }
        
          if(add_arr.length > 0) {
            await new this.$apiAction().addJobs(add_arr, token).then((res) => {
                  console.log(res)
                }).catch((err) => {
                    console.log(err)
                });
          }
          if(rem_arr.length > 0) {
            rem_arr.forEach(async id => {
              await new this.$apiAction().removeJobfromJobfair(id, job_id, token).then((res) => {
                if(res.status == true) {
                  console.log(res)
                }
                }).catch((err) => {
                    console.log(err)
                });
            })
          }
      },
      editJob: function(e){
        e.preventDefault();
        var city = null;
        this.can_post = 0;
        if(!this.toPost.jobs.job_designation){
          this.can_post++;
        }
        if(this.toPost.cities.length == 0){
          this.can_post++;
        }
        if(this.toPost.courses.length == 0){
          this.can_post++;
        }
        if(this.validate.numberValidation(this.toPost.jobs.salary_range_from, "min_salary")?.val === false){
          this.can_post++;
        }
        if(this.validate.numberValidation(this.toPost.jobs.salary_range_to, "max_salary")?.val === false && this.toPost.jobs.salary_range_to){
            this.can_post++;
        }
        if(this.selected_jobfairs.length == 0 && (this.toPost.job_custom.job_fair_display == 2 || this.toPost.job_custom.job_fair_display ==3)){
          this.can_post++;
        }
        // if(this.validate.checkIfEmpty(this.toPost.jobs.salary_range_from, "salary", 'Select Minimum Salary')?.val === false){
        //   this.can_post++;
        // }
        if(!this.toPost.jobs.job_type){
          this.can_post++;
        }
        if(this.toPost.jobs.hiring_process.length == 0){
          this.can_post++;
        }
        if(this.validate.checkIfEmpty(this.toPost.jobs.job_description, "description", 'Enter Description')?.val === false){
          this.can_post++;
        }
        if(this.toPost.jobs.company_name ==''){
          this.can_post++
        }
        if(this.can_post === 0){
          this.states.forEach(data => {
            if(data.id && data.id == this.toPost.cities[0]?.city_id){
              city= data.text  
            }
        })
        var s_description = (this.toPost.jobs.job_description)?this.toPost.jobs.job_description.replace( /(<([^>]+)>)/ig, ''):'';
        this.toPost.jobs.seo_title = this.toPost.jobs.job_designation + ' jobs in '+ city+' - '+this.toPost.jobs.company_name;
        this.toPost.jobs.seo_description = (this.toPost.jobs.job_designation + ' jobs in '+ city+' - '+this.toPost.jobs.company_name+' - '+s_description).substr(0,200);
        this.toPost.jobs.seo_keywords = [this.toPost.jobs.job_designation,city,this.toPost.jobs.company_name].join();
        this.toPost.jobs.hiring_process=(this.toPost.jobs.hiring_process && typeof this.toPost.jobs.hiring_process!= 'string')?this.toPost.jobs.hiring_process.join():((typeof this.toPost.jobs.hiring_process== 'string')?this.toPost.jobs.hiring_process:null);
        this.toPost.jobs.salary_range_to = (this.toPost.jobs.salary_range_to)?this.toPost.jobs.salary_range_to:null;
        if(this.toPost.jobs.experience_from == 1){
          this.toPost.jobs.experience_from = 0;
        }
        if(this.toPost.jobs.experience_to == 1){
          this.toPost.jobs.experience_to = 0;
        }
        let token = this.$cookies.get("hire-employer").token;
        new this.$apiAction().jobEdit(this.$route.params.id,this.version_id,this.toPost, token).then((res) => {
          console.log(res);
          if(res.error == 0){
                this.updateJobs(this.$route.params.id);
                this.openModal("success");
                setTimeout(() => {
                  this.$refs["job-success"].hide();
                  this.$router.push('/recruit/client-job-dashboard');
                },1000)
              // this.$router.push('/recruit/client-job-dashboard');
            }else {
            console.log("empty field", this.can_post,);
          }
        }).catch((err) => {
          console.log(err);
        })
        }else {
          console.log("empty field", this.can_post,);
        }
      },

      getJobDetails(id,type,u_id){
        new this.$apiAction().getJobDetails({id:id,type:type, user_id:u_id}).then(res => {
          if(res.data.type[0] == '2') this.private_edit = true;
          this.toPost.jobs.client_user_id = res.data.jobs.client_user_id;
          this.toPost.jobs.job_designation = res.data.jobs.job_designation;
          this.toPost.jobs.job_role = res.data.jobs.job_role;
          this.setJobeRole(this.toPost.jobs.job_role);
          this.toPost.jobs.company_name = res.data.jobs.company_name;
          this.toPost.jobs.last_date = res.data.jobs.last_date;
          this.toPost.jobs.hiring_process = res.data.jobs.hiring_process;
          this.toPost.jobs.job_description = res.data.jobs.job_description;
          this.toPost.jobs.priority = res.data.jobs.priority;
          this.toPost.jobs.seo_title = res.data.jobs.seo_title;
          this.toPost.jobs.seo_description = res.data.jobs.seo_description;
          this.toPost.jobs.seo_keywords = res.data.jobs.seo_keywords;
          this.toPost.jobs.gender = res.data.jobs.gender;
          this.toPost.jobs.response_type = res.data.jobs.response_type;
          this.toPost.jobs.posted_by_id = res.data.jobs.posted_by_id;
          this.toPost.jobs.salary_range_from = res.data.jobs.salary_range_from;
          this.toPost.jobs.salary_range_to = res.data.jobs.salary_range_to;
          this.toPost.jobs.job_role = res.data.jobs.job_role;
          this.toPost.jobs.salary_flag = res.data.jobs.salary_flag;
          this.toPost.jobs.hq_marks_percentage_from = res.data.jobs.hq_marks_percentage_from;
          this.toPost.jobs.number_of_vacancy = res.data.jobs.number_of_vacancy;
          this.toPost.jobs.experience_from = res.data.jobs.experience_from;
          this.toPost.jobs.experience_to = res.data.jobs.experience_to;
          this.toPost.jobs.year_of_passing_from = res.data.jobs.year_of_passing_from;
          this.toPost.jobs.year_of_passing_to = res.data.jobs.year_of_passing_to;
          this.toPost.job_custom.organic_status = res.data.job_custom.organic_status;
          this.toPost.job_custom.mode = res.data.job_custom.mode;
          this.toPost.job_custom.job_fair_display = res.data.job_custom.job_fair_display;
          if(this.private_edit) {
            this.toPost.job_custom.marquee_text = res.data.job_custom.marquee_text;
            if(res.data.job_desc_pdf.length > 0){
              this.toPost.job_custom.job_desc_pdf = res.data.job_desc_pdf[0];
              this.job_desc_pdf = res.data.job_desc_pdf[0];
            }
            if(res.data.form_img.length > 0){
              this.toPost.job_custom.form_img = res.data.form_img[0];
              this.form_img = res.data.form_img[0];
            }
            if(res.data.header_img.length > 0){
              this.toPost.job_custom.header_img = res.data.header_img[0];
              this.header_img = res.data.header_img[0];
            }
            if(res.data.job_video.length > 0){
              this.toPost.job_custom.job_video = res.data.job_video[0];
              this.job_video = res.data.job_video[0];
            }

          }
          
          this.version_id = res.data.jobs.jobversion_id;
          let split_date = this.toPost.jobs.last_date.split('-');
          this.toPost.jobs.last_date = split_date[2]+'-'+split_date[1]+'-'+split_date[0];
          // this.job = res.data.jobs;
          res.data.cities.forEach(city => {
            this.t_city.push(JSON.parse(city));
          })
          if(res.data.sublocations.length){
            res.data.sublocations.forEach(location => {
              this.t_location.push(JSON.parse(location));
              this.showSubcity();
              this.setSublocations();
            })
          }else{
            this.toPost.cities = [];
            this.t_city.forEach(data => {
              this.toPost.cities.push({city_id: data})
            })
          }
          res.data.courses.forEach(course => {
            this.t_courses.push(JSON.parse(course));
          })
          if(res.data.jobfair_id.length) {
            res.data.jobfair_id.forEach(id => {
              this.selected_jobfairs.push(JSON.parse(id));
              this.existing_jobfairs.push(JSON.parse(id));
            })
          }
          if(res.data.branches.length){
            res.data.branches.forEach(branch => {
              this.t_branches.push(JSON.parse(branch));
              this.getBranches();
              this.setBranches();
            })
          }else{
            this.toPost.courses = [];
            this.t_courses.forEach(data => {
              this.toPost.courses.push({course_id: data})
            })
          }
          if(res.data.skills.length){
            res.data.skills.forEach(skill => {
              this.t_skills.push(JSON.parse(skill));
              this.setSkills();
            })
          }
          if(res.data.jobs.salary_flag == 1){
            document.getElementById('hidesalary').checked = true;
          }else{
            document.getElementById('hidesalary').checked = false;
          }
          if(res.data.jobs.hiring_process){
            var hiring_process = res.data.jobs.hiring_process.split(',');
            this.toPost.jobs.hiring_process = hiring_process;
            hiring_process.forEach(hire_split => {
              this.hire_process.forEach(hire => {
                if(hire.text == hire_split){
                  this.default_hiring.push(hire);
                }
              })
            })
          }
          if(res.data.jobs.job_type){
            this.job_type.forEach(j_type => {
              if(j_type.value == res.data.jobs.job_type){
                this.default_type = j_type;
              }
            })
          }
          // if(res.data.jobs.gender){
          //   this.gender.forEach(g => {
          //     if(g.value == res.data.jobs.gender){
          //       this.to
          //     }
          //   })
          // }
        if(this.toPost.jobs.experience_from == 0){
          this.toPost.jobs.experience_from = 1;
        }
        if(this.toPost.jobs.experience_to == 0){
          this.toPost.jobs.experience_to = 1;
        }
        this.toPost.jobs.seo_title = null,
        this.toPost.jobs.seo_description = null;
        this.toPost.jobs.seo_keywords = null;
        delete this.toPost.jobs.date_of_posting;
        });
      },
    },
  //     watch: {
  //   menu (val) {
  //     val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
  //   }
  // },
  }
</script>

<style>
  @import "~vue2-editor/dist/vue2-editor.css";

  /* Import the Quill styles you want */
  @import '~quill/dist/quill.core.css';
  @import '~quill/dist/quill.bubble.css';
  @import '~quill/dist/quill.snow.css';
</style>